import { CURRENT_YEAR } from '@/constant/common';
import { getGlobalArgs } from '@/root/global';

export type RightItem = {
  label: string;
  link: string;
};

type RightSignature = {
  host: RightItem;
  common: RightItem[];
};

const CLOUD_URL = getGlobalArgs('NEXT_PUBLIC_CONTENT_BASE_URL', '/');

export const rights: RightSignature = {
  host: { label: `© ${CURRENT_YEAR} Cloud.ru`, link: CLOUD_URL },
  common: [
    { label: 'Поддержка', link: 'https://cloud.ru/docs/evolution/overview/contacts/technical-support.html' },
    { label: 'Юридические документы', link: `${CLOUD_URL}/documents` },
  ],
};
